import { merge } from 'lodash';

import root from './root';
import sizes from './sizes';

const iconbutton = {
  defaultProps: {
    disableFocusRipple: true,
    disableRipple: true
  },
  styleOverrides: merge(
    { root: { ...root } },
    // Sizes Styling
    { ...sizes }
  )
};

export default iconbutton;
